import React from 'react';
import heroLogo from 'assets/images/midnightswim/logomarkandtexttitle.png';
import aquaristLogo from 'assets/images/aquarist/aquaristLogo.png';
import idleCafeLogo from 'assets/images/idleCafe/appicon.png';
import { HomeTemplate } from 'templates';

const HomePage: React.FC = () => {
  return (
    <HomeTemplate
      heroLogo={heroLogo}
      aquaristLogo={aquaristLogo}
      idleCafeLogo={idleCafeLogo}
    />
  );
};

export default HomePage;
